import * as THREE from 'three';

/** Breadcrumbs of where she has walked; used to put him back behind her, out of sight. */
export class Trail {
  private readonly points: THREE.Vector3[] = [];
  private readonly spacing = 1;
  private readonly max = 900;

  clear(): void {
    this.points.length = 0;
  }

  record(p: THREE.Vector3): void {
    const last = this.points[this.points.length - 1];
    if (last && last.distanceToSquared(p) < this.spacing * this.spacing) return;
    this.points.push(new THREE.Vector3(p.x, 0, p.z));
    if (this.points.length > this.max) this.points.shift();
  }

  /** Point `distance` metres back along her path from `from`. */
  pointBehind(from: THREE.Vector3, distance: number, out: THREE.Vector3): boolean {
    let remaining = distance;
    let px = from.x;
    let pz = from.z;
    for (let i = this.points.length - 1; i >= 0; i -= 1) {
      const q = this.points[i];
      const d = Math.hypot(q.x - px, q.z - pz);
      if (d >= remaining && d > 0) {
        const t = remaining / d;
        out.set(px + (q.x - px) * t, 0, pz + (q.z - pz) * t);
        return true;
      }
      remaining -= d;
      px = q.x;
      pz = q.z;
    }
    return false;
  }
}
